export default "__VITE_ASSET__DTFb2yGa__"